export function uniqPush<T>(array: T[], value: T) {
    if (!array.includes(value)) return array.push(value);

    return array.push();
}

export function allEqual<T>(array: T[]) {
    return array.every((v) => v === array[0]);
}

export function flattenArray<T>(arr: T[]) {
    return arr.reduce(
        (previousValue, currentValue) =>
            Array.isArray(currentValue)
                ? previousValue.concat(flattenArray(currentValue))
                : previousValue.concat(currentValue),
        [],
    );
}

/** 移动元素到指定的位置 */
export function move<T>(arr: T[], originIndex: number, targetIndex: number) {
    if (targetIndex >= arr.length) {
        let i = targetIndex - arr.length + 1;

        while (i--) {
            arr.push(undefined);
        }
    }

    arr.splice(targetIndex, 0, arr.splice(originIndex, 1)[0]);

    return arr;
}

export function arrayMoveMutable<T>(array: T[], fromIndex: number, toIndex: number) {
    const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

    if (startIndex >= 0 && startIndex < array.length) {
        const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

        const [item] = array.splice(fromIndex, 1);
        array.splice(endIndex, 0, item);
    }
}

export function arrayMoveImmutable<T>(array: T[], fromIndex: number, toIndex: number) {
    const newArray = [...array];
    arrayMoveMutable(newArray, fromIndex, toIndex);
    return newArray;
}

export function getNeedUpdateMoveDataSource<T extends {}>(
    oldDataSource: T[],
    movedDataSource: T[],
    options: {
        indexKey: keyof T;
        idKey: keyof T;
    },
) {
    const { indexKey, idKey } = options;

    // 如果有没有字段的index
    const hasUndefinedIndex = oldDataSource.some((it) => typeof it[indexKey] === "undefined" || it[indexKey] === null);

    if (hasUndefinedIndex) {
        return movedDataSource.map((it, index) => {
            // @ts-ignore
            it[indexKey] = index;

            return it;
        });
    }

    let hasSameIndex = false;
    let sameMapping = new Map<any, boolean>();
    for (let i = 0; i < movedDataSource.length; i++) {
        const data = movedDataSource[i];

        if (sameMapping.get(data[indexKey])) {
            hasSameIndex = true;
            break;
        }

        sameMapping.set(data[indexKey], true);
    }

    if (hasSameIndex) {
        return movedDataSource.map((it, index) => {
            // @ts-ignore
            it[indexKey] = index;

            return it;
        });
    }

    const oldDataSourceIndexes = oldDataSource.map((it) => {
        return it[indexKey];
    });

    const newDataSource: T[] = movedDataSource
        .filter((it) => !!it)
        .map((it, index) => {
            const trueIndex = oldDataSourceIndexes[index];

            return {
                ...it,
                [indexKey]: trueIndex,
            };
        });

    const needUpdateMoveDataSource: T[] = newDataSource.filter((newData) => {
        // 过滤掉index未改变的分组
        const oldData = oldDataSource.find((library) => library[idKey] === newData[idKey]);

        if (newData[indexKey] === oldData[indexKey]) {
            return false;
        }

        return true;
    });

    return needUpdateMoveDataSource;
}
